import { render, staticRenderFns } from "./AIOTTabs.vue?vue&type=template&id=69b3186b&scoped=true"
import script from "./AIOTTabs.vue?vue&type=script&lang=js"
export * from "./AIOTTabs.vue?vue&type=script&lang=js"
import style0 from "./AIOTTabs.vue?vue&type=style&index=0&id=69b3186b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b3186b",
  null
  
)

export default component.exports